/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Hero_DescInputs */

const en_nfp_hero_desc = /** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditch the fragmented tools. Launch a unified, verified hub for your congregation or charity. Integrated private discussions, secure digital material delivery, and automated tax-exempt receipting.`)
};

const es_nfp_hero_desc = /** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza un centro unificado y verificado para tu congregación o fundación. Discusiones privadas, entrega de material digital seguro y recibos automáticos.`)
};

const fr_nfp_hero_desc = /** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonnez les outils fragmentés. Lancez un hub unifié et vérifié pour votre congrégation ou votre association. Discussions privées intégrées, livraison sécurisée de matériel numérique et reçus automatiques exonérés d'impôts.`)
};

const de_nfp_hero_desc = /** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzichte auf fragmentierte Tools. Starte einen einheitlichen Hub für deine Gemeinde oder Wohltätigkeitsorganisation.`)
};

const id_nfp_hero_desc = /** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan alat yang terfragmentasi. Luncurkan hub terpadu yang terverifikasi untuk jemaat atau badan amal Anda. Dilengkapi diskusi pribadi terpadu, pengiriman materi digital yang aman, dan penerbitan tanda terima bebas pajak yang otomatis.`)
};

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const ja_nfp_hero_desc = en_nfp_hero_desc;

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const zh_nfp_hero_desc = en_nfp_hero_desc;

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const ar_nfp_hero_desc = en_nfp_hero_desc;

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const it_nfp_hero_desc = en_nfp_hero_desc;

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const ru_nfp_hero_desc = en_nfp_hero_desc;

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const pt_nfp_hero_desc = en_nfp_hero_desc;

/** @type {(inputs: Nfp_Hero_DescInputs) => LocalizedString} */
const ko_nfp_hero_desc = en_nfp_hero_desc;

/**
* | output |
* | --- |
* | "Ditch the fragmented tools. Launch a unified, verified hub for your congregation or charity. Integrated private discussions, secure digital material delivery..." |
*
* @param {Nfp_Hero_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_hero_desc = /** @type {((inputs?: Nfp_Hero_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Hero_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_hero_desc(inputs)
	if (locale === "es") return es_nfp_hero_desc(inputs)
	if (locale === "fr") return fr_nfp_hero_desc(inputs)
	if (locale === "de") return de_nfp_hero_desc(inputs)
	if (locale === "ja") return ja_nfp_hero_desc(inputs)
	if (locale === "zh") return zh_nfp_hero_desc(inputs)
	if (locale === "ar") return ar_nfp_hero_desc(inputs)
	if (locale === "id") return id_nfp_hero_desc(inputs)
	if (locale === "it") return it_nfp_hero_desc(inputs)
	if (locale === "ru") return ru_nfp_hero_desc(inputs)
	if (locale === "pt") return pt_nfp_hero_desc(inputs)
	return ko_nfp_hero_desc(inputs)
});